
/**
 * Keeps the left thumbnail column the exact same height as the main
 * product media slider when gallery_layout = "thumbnail_left".
 */
(function () {
  function getParts(mediaGallery) {
       var mainSlider = mediaGallery.querySelector('slider-component:not(.thumbnail-slider) .product__media-list');
    var thumbSlider = mediaGallery.querySelector('.thumbnail-slider');
    return { mainSlider: mainSlider, thumbSlider: thumbSlider };
  }

  function syncHeight(mediaGallery) {
    if (!mediaGallery || mediaGallery.dataset.desktopLayout !== 'thumbnail_left') return;

    var parts = getParts(mediaGallery);
    if (!parts.mainSlider || !parts.thumbSlider) return;

    if (window.matchMedia('(min-width: 750px)').matches) {
      var height = parts.mainSlider.offsetHeight;
      if (height > 0) {
        parts.thumbSlider.style.height = height + 'px';
      }
    } else {
      parts.thumbSlider.style.height = '';
    }
  }

  function syncAll() {
    document.querySelectorAll('media-gallery').forEach(syncHeight);
  }

  function observe(mediaGallery) {
    var parts = getParts(mediaGallery);
    if (!parts.mainSlider) return;

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () {
        syncHeight(mediaGallery);
      });
      ro.observe(parts.mainSlider);
    }

    // Re-sync whenever a new image/slide becomes active (variant change, click, etc.)
    var mo = new MutationObserver(function () {
      syncHeight(mediaGallery);
    });
    mo.observe(parts.mainSlider, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }

  function scrollActiveThumbnailIntoView(thumbSlider) {
    if (!thumbSlider) return;
    var activeButton = thumbSlider.querySelector('.thumbnail[aria-current="true"]');
    if (!activeButton) return;

    activeButton.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest'
    });
  }

  function observeActiveThumbnail(mediaGallery) {
    var parts = getParts(mediaGallery);
    if (!parts.thumbSlider) return;

    var list = parts.thumbSlider.querySelector('.thumbnail-list');
    if (!list) return;

    // Click: scroll right away for a snappy feel.
    list.addEventListener('click', function (event) {
      var button = event.target.closest('.thumbnail');
      if (button) {
        requestAnimationFrame(function () {
          scrollActiveThumbnailIntoView(parts.thumbSlider);
        });
      }
    });

    // Covers cases where the active thumbnail changes without a direct click
    // on it (e.g. next/prev arrows on the main image, variant selection).
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'aria-current') {
          scrollActiveThumbnailIntoView(parts.thumbSlider);
          break;
        }
      }
    });
    mo.observe(list, { attributes: true, subtree: true, attributeFilter: ['aria-current'] });
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(function (mediaGallery) {
      if (mediaGallery.dataset.desktopLayout !== 'thumbnail_left') return;

      syncHeight(mediaGallery);
      observe(mediaGallery);
      observeActiveThumbnail(mediaGallery);

      var parts = getParts(mediaGallery);
      scrollActiveThumbnailIntoView(parts.thumbSlider);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', syncAll);
  window.addEventListener('resize', syncAll);
  document.addEventListener('variant:change', syncAll);
  document.addEventListener('shopify:section:load', init);
})();